jQuery(document).ready(function($) {
	// get the token injected on the page that has the id and email of the logged in user
	let user_token = $("#user-token").text();
	let cvl = $("#pbx-config").text();
	let pbx_config = JSON.parse(cvl ? cvl : '{"empty": true}');
	let project_id = new URLSearchParams(window.location.search).get('project_id');
	let session_id = "";
	let inPopup = false;
	let auth_iframe = null;
	let auth_dialog = null;
	let note_dialog = null;

	if (user_token != "") {
		// show and hide elements based on an authenticated user
		$(".show_if_authenticated").show();
		$(".show_if_not_authenticated").hide();

	} else {
		// show and hide elements based on NO authenticated user
		$(".show_if_authenticated").hide();
		$(".show_if_not_authenticated").show();
	}

	if (session_id == "" && user_token != "") {
		// there's a valid token so send it to the backend to get the pb session id from it
		$.ajax({
			type: "GET",
			url: 'https://honeybeesoftserve.com/honeybeeprint/session_id?token=' + user_token,
			dataType: "json",
			success: function (results) {
				session_id = results["data"];
				switch(pbx_config.display) {
					case "editor":
						printbox.setEditorConfig({
							storeName: "default_store",
							productFamilyId: pbx_config.productFamilyId,
							projectId: project_id ? project_id : "",
							sessionId: session_id,
							language: "en",
							translationsLanguage: "en",
							contentLanguage: "en",
							locale: "en-us",
							currency: "USD"
						});
						break;
					case "products":
						printbox.setProjectsListConfig({
							storeName: "default_store",
							sessionId: session_id,
							instanceId: "default",
							language: "en"
						});
						break;
				}
			}
		});
	} else {
		if (pbx_config.display == "editor") {
			printbox.setEditorConfig({
				storeName: "default_store",
				productFamilyId: pbx_config.productFamilyId,
				projectId: project_id ? project_id : "",
				language: "en",
				translationsLanguage: "en",
				contentLanguage: "en",
				locale: "en-us",
				currency: "USD"
			});
		}
	}

	printbox.authUserRequest = function() {
		return new Promise(function(resolve, reject) {
			if (session_id != "") {
				resolve(session_id);
			} else {
				if (!inPopup) {
					inPopup = true;
					// need a user token so pop up the my-account page to allow authentication
					auth_iframe = getIFrame();
					auth_iframe[0].onload = function() {
						let failed = false;
						try {
							if (auth_iframe[0].contentWindow.location.pathname != "/my-account/") {
								failed = true;
							}
						} catch(exception) {
							failed = true;
						}
						if (failed) {
							auth_dialog.dialog('close');
							note_dialog = $('<div id="note-popup-dialog" style="padding: 20px;">Hey, we\'re sorry but that social login didn\'t work in this pop up.</br></br>Please <a href="https://honeybeeprint.com/my-account" target="_blank">click or touch here</a> to open My Account in a new tab and log in there.<br/><br/>When done, close the other tab and click <b>Continue</b> below to retry.</div>').appendTo("body").dialog({
								autoOpen: false,
								modal: false,
								title: "Log In Failed",
								height: 400,
								width: 420,
								resizable: true, 
								position: {
									my: "center top",
									at: "center top",
									of: window,
									collision: "none"
								}, 
								create: function (event, ui) {
									$(event.target).parent().css('position', 'fixed');
								},
								buttons: {
									"Continue": function(event, ui) {
										note_dialog.dialog('close');
									}
								},
								close: function() {
									note_dialog.dialog('destroy').remove();
									final_iframe = getIFrame();
									final_dialog = getDialog(final_iframe, resolve, reject);
									final_dialog.dialog('open');
								}
							});
							note_dialog.dialog('open');
						}
					}
					auth_dialog = getDialog(auth_iframe, resolve, reject);
					auth_dialog.dialog('open');
				}
			}
		});
	};

	function getIFrame() {
		return $('<iframe id="login-popup-iframe" style="border: 0px;" src="/my-account" width="100%" height="99%"></iframe>');
	}

	function getDialog(ifrm, res, rej) {
		$('<style>.no-close .ui-dialog-titlebar-close {display: none;}</style>').appendTo("body");
		let dlg = $('<div id="login-popup-dialog" style="padding: 5px;"></div>').append(ifrm).appendTo("body").dialog({
			autoOpen: false,
			modal: false,
			title: "Log In",
			height: 780,
			width: 420,
			resizable: true, 
			position: {
				my: "center top",
				at: "center top",
				of: window,
				collision: "none"
			}, 
			dialogClass: "no-close",
			create: function (event, ui) {
				$(event.target).parent().css('position', 'fixed');
			},
			close: function() {
				// user authenticated so get token and change it into a session id
				user_token = $("#user-token").text();
				if (user_token != "") {
					inPopup = false;
					$.ajax({
						type: "GET",
						url: 'https://honeybeesoftserve.com/honeybeeprint/session_id?token=' + user_token,
						dataType: "json",
						success: function (results) {
							session_id = results["data"];
							res(session_id);
						},
						error: function() {
							rej();
						}
					});
				}
				dlg.dialog('destroy').remove();
			}
		});
		return dlg;
	}

	function delay(time) {
		return new Promise(resolve => setTimeout(resolve, time));
	}

	printbox.goToCartFinished = function(projectId) {
		return new Promise(function(resolve, reject) {
			$.ajax({
				type: "GET",
				url: 'https://honeybeesoftserve.com/honeybeeprint/products_to_add?project_id=' + projectId,
				dataType: "json",
				success: function (results) {
					console.log("Products: ");
					console.log(results);
					$.ajax({
						type: "POST",
						url: "https://honeybeeprint.com/wp-json/cocart/v2/cart/add-items",
						data: results["data"],
						dataType: "json",
						contentType: "application/json; charset=utf-8",
						complete: function (response) {
							console.log("New Item Added: ")
							console.log(response);
							printbox.disableExitWarning();
							delay(500).then(() => window.location = '/cart');
						}
					});
					resolve(true);
				},
				error: function() {
					reject();
				}
			});
		});
	}

	printbox.addProjectToCart = function(projectId) {
		return new Promise(function(resolve, reject) {
			$.ajax({
				type: "GET",
				url: 'https://honeybeesoftserve.com/honeybeeprint/products_to_add?project_id=' + projectId,
				dataType: "json",
				success: function (results) {
					console.log("Products: ");
					console.log(results);
					$.ajax({
						type: "POST",
						url: "https://honeybeeprint.com/wp-json/cocart/v2/cart/add-items",
						data: results["data"],
						dataType: "json",
						contentType: "application/json; charset=utf-8",
						complete: function (response) {
							console.log("New Item Added: ")
							console.log(response);
						}
					});
					resolve(true);
				},
				error: function() {
					reject();
				}
			});
		});
	};

	printbox.removeProjectFromCart = function(projectId) {
		return new Promise(function(resolve, reject) {
			resolve(true);
		});
	};

	printbox.goToCart = function(projectId) {
		return new Promise(function(resolve, reject) {
			printbox.disableExitWarning();
			window.location = '/cart';
			resolve(true);
		});
	};


	printbox.redirectToEditor = function(projectId, productFamilyId) {
		return new Promise(function(resolve, reject) {
			switch(productFamilyId) {
				case 18:
					window.location = '/photo-book-original-editor?project_id=' + projectId
					break;
				case 65:
					window.location = '/photo-book-editor?project_id=' + projectId
					break;
				case 31:
					window.location = '/card-editor?project_id=' + projectId
					break;
				case 27:
					window.location = '/print-editor?project_id=' + projectId
					break;
				case 59:
					window.location = '/journal-editor?project_id=' + projectId
					break;
				case 21:
					window.location = '/calendar-editor?project_id=' + projectId
					break;
			}
			resolve(true);
		});
	};
});
